/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachines/ActionsCreators/VirtualMachineResourceActionCreator" />

import { IVssPageContext } from "VSS/Platform/Context";

import { PackageMetadata } from "DistributedTask/Client/Contracts/TaskAgent";

import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";
import { getErrorMessage } from "Environments/EnvironmentsCommon/Utils";
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { VirtualMachineResourceActions } from "Environments/ProviderCreateDetails/VirtualMachines/Actions/VirtualMachineResourceActions";
import { IVirtualMachineResourceService } from "Environments/ProviderCreateDetails/VirtualMachines/Services/VirtualMachineResourceServices";
import { PageKey } from "Environments/ProviderCreateDetails/VirtualMachines/Utilities";

export class VirtualMachineResourceActionCreator extends ActionCreatorBase {

    public static getKey(): string {
        return "virtualmachines-add-actions-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);
        
        this._actions = ActionsHubManager.CreateActionsHub<VirtualMachineResourceActions>(VirtualMachineResourceActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions> (MessagesActions, instanceId);
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<VirtualMachineResourceActions>(VirtualMachineResourceActions, this.getInstanceId());
    }

    public getTargetPackages(pageContext: IVssPageContext) {
        let virtualMachineGroupService = pageContext.getService<IVirtualMachineResourceService>("IVirtualMachineResourceService");
        virtualMachineGroupService.getTargetPackages().then((packages: PackageMetadata[]) => {
            this._actions.setTargetPackages.invoke(packages);
        }, (error: any) => {
            this._messageActions.addMessage.invoke({ key: PageKey.AgentPackageGet, value: getErrorMessage(error) });
        });
    }

    private _actions: VirtualMachineResourceActions;
    private _messageActions: MessagesActions;
}